import { useThrottledTimelineCursorTime } from 'app/agriculture/AgTimeline/context/TimelineContext';
import { useMemo } from 'react';

interface UseCursorTimeArgs {
    override?: Date;
    throttleDelay?: number;
}

export function useCursorTime({ override, throttleDelay = 500 }: UseCursorTimeArgs = {}) {
    const throttledCursorTime = useThrottledTimelineCursorTime({ throttleDelay });

    return useMemo(() => {
        return override ?? throttledCursorTime;
    }, [override, throttledCursorTime]);
}
